import EnglishText from './locales/en.json';
import GermanText from './locales/de.json';

const messages = {
    'de': GermanText,
    'en': EnglishText
};

export { messages };